// extracted by mini-css-extract-plugin
export default {"filterGroup":"Program_filterGroup__V34Y8"};